import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AccessGate from "./AccessGate";
import Home from "./components/Home";
import Projects from "./components/Projects";
import CaseStudyVShred from "./components/CaseStudyVShred";
import CaseStudyWiley from "./components/CaseStudyWiley";
import DynamicCaseStudy from "./components/DynamicCaseStudy";
import CaseStudyLayouts from "./components/CaseStudyLayouts";

const secretCode = "aslearnmore";

function App() {
  const [accessGranted, setAccessGranted] = useState(false);

  useEffect(() => {
    // Check sessionStorage for access flag on mount
    const granted = sessionStorage.getItem("accessGranted");
    if (granted === "true") {
      setAccessGranted(true);
    }
  }, []);

  const handleAccessGranted = () => {
    setAccessGranted(true);
    sessionStorage.setItem("accessGranted", "true");
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/gate"
          element={
            <AccessGate
              correctCode={secretCode}
              onAccessGranted={handleAccessGranted}
            />
          }
        />
        <Route
          path="/home"
          element={
            accessGranted ? <Home /> : <AccessGate correctCode={secretCode} onAccessGranted={handleAccessGranted} />
          }
        />
        <Route
          path="/"
          element={<AccessGate correctCode={secretCode} onAccessGranted={handleAccessGranted} />}
        />
        <Route path="/case-studies" element={<Projects />} />
        {/* Dynamic route for Airtable-powered case studies - must come first */}
        <Route path="/case-studies/:slug" element={<DynamicCaseStudy />} />
        {/* Static routes for existing case studies - fallback only */}
        <Route path="/case-studies/v-shred-static" element={<CaseStudyVShred />} />
        <Route path="/case-studies/wiley-static" element={<CaseStudyWiley />} />
        <Route path="/case-study-layouts" element={<CaseStudyLayouts />} />
      </Routes>
    </Router>
  );
}

export default App;
